import { Anchor, Breadcrumbs, Text } from '@mantine/core';
import queryString from 'query-string';
import { useLocation, useNavigate, useParams } from 'react-router';
import BannersNewForm from '../../../components/Banners/BannersNewForm';
import Metadata from '../../../components/Metadata';
import { Page } from '../../../constants/pageTitles';

const BannersNewPage = () => {
  const pageTitle = `${Page.banners}`;
  const navigate = useNavigate();
  const location = useLocation();
  const { accountId, domainId } = useParams();
  const { from } = queryString.parse(location.search);

  return (
    <>
      <Metadata title={`${pageTitle} | New`} />
      <Breadcrumbs mb="md">
        <Anchor href={`#/accounts/${accountId}/domains/${domainId}/analytics`}>Home</Anchor>
        <Anchor href={`#/accounts/${accountId}/domains/${domainId}/banners`}>Banners</Anchor>
        <Text>New</Text>
      </Breadcrumbs>

      <BannersNewForm
        from={from}
        onSuccess={() => navigate(`/accounts/${accountId}/domains/${domainId}/banners`)}
        onBack={() => navigate(`/accounts/${accountId}/domains/${domainId}/banners`)}
      />
    </>
  );
};

export default BannersNewPage;
